// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'd49a4be3-9718-4612-9661-7ad65362b34f',
      type: 'Sprite',
      name: 'island',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Island',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        name: 'SNOW MOUNTAIN',
        atlas: 'diorama_3',
        reward: {
          'Coin': 100,
          'BoosterMove': 1,
        }
      }
    },
    {
      id: '791de644-e71c-4935-8841-5df01dc5201a',
      type: 'Sprite',
      name: 'bridgeShadow',
      className: '',
      x: 7,
      y: -440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Bear_Bridge_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: 'c44cee00-afd3-43cc-8573-f7d513444647',
      type: 'Sprite',
      name: 'bridge',
      className: '',
      x: -4,
      y: -456,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Bear_Bridge',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1100,
        order: 5
      }
    },
    {
      id: '79fde6f8-4676-4a38-a1f4-fa5bb42fefac',
      type: 'Sprite',
      name: 'barShadow',
      className: '',
      x: 215,
      y: -388,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Bar_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '47b2fda5-5322-4bef-ad54-a3f688020961',
      type: 'Sprite',
      name: 'bar',
      className: '',
      x: 204,
      y: -440,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Bar',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 1270,
        order: 6
      }
    },
    {
      id: '1adb3f49-417c-46d1-a545-0932ba5d3208',
      type: 'Sprite',
      name: 'cabinShadow',
      className: '',
      x: -155,
      y: -325,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Cabin_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '51acb1b9-744e-4469-b300-7d9e6c5d72da',
      type: 'Sprite',
      name: 'cabin',
      className: '',
      x: -174,
      y: -392,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Cabin',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 500,
        order: 1
      }
    },
    {
      id: 'feaca622-9b4f-41c5-8119-92e2d7e36f82',
      type: 'Sprite',
      name: 'snowmobileShadow',
      className: '',
      x: -137,
      y: -166,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Snow_Mobile_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '9b0c21c2-8131-4b13-8c84-e393f14ae4b8',
      type: 'Sprite',
      name: 'snowmobile',
      className: '',
      x: -148,
      y: -180,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Snow_Mobile',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 600,
        order: 2
      }
    },
    {
      id: 'b2b9fe46-bb77-4a49-b4f5-4727cec567f1',
      type: 'Sprite',
      name: 'iglooShadow',
      className: '',
      x: -12,
      y: -347,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Igloo_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '1239f990-f8e9-4e8d-a1da-a3c3b68fe16b',
      type: 'Sprite',
      name: 'igloo',
      className: '',
      x: -21,
      y: -378,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Igloo',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 900,
        order: 4
      }
    },
    {
      id: '278c61b2-3112-4633-81c0-0ac14df4d625',
      type: 'Sprite',
      name: 'storeShadow',
      className: '',
      x: 131,
      y: -212,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Store_Shadow',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4'
    },
    {
      id: '531595f5-2a60-4916-b9d0-a196789587ad',
      type: 'Sprite',
      name: 'store',
      className: '',
      x: 112,
      y: -233,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Diorama_3_Store',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        price: 650,
        order: 3
      }
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  handleResize: false
} as const;

export class Diorama_3 {
  static raw = raw;
  root!: Container;
  island!: Sprite & { data: typeof raw['list'][1]['data'] };
  bridgeShadow!: Sprite;
  bridge!: Sprite & { data: typeof raw['list'][3]['data'] };
  barShadow!: Sprite;
  bar!: Sprite & { data: typeof raw['list'][5]['data'] };
  cabinShadow!: Sprite;
  cabin!: Sprite & { data: typeof raw['list'][7]['data'] };
  snowmobileShadow!: Sprite;
  snowmobile!: Sprite & { data: typeof raw['list'][9]['data'] };
  iglooShadow!: Sprite;
  igloo!: Sprite & { data: typeof raw['list'][11]['data'] };
  storeShadow!: Sprite;
  store!: Sprite & { data: typeof raw['list'][13]['data'] };
  StateName!: never;

  constructor() {
    populate(this, raw);
  }
}
